import Container from '@/container';
import {Row, Col} from '@/grid';
import Img from '@/images';
import {useTranslations} from 'next-intl';
import Link from '@/links';
import styles from './ai-summary.module.scss';
import aiLogos from './ai-logos.json';

const AISummary = () => {
  const t = useTranslations('shared.aiSummary');
  const urlSafePrompt = encodeURIComponent(t('prompt'));
  return (
    <Container className="no-print">
      <Row>
        <Col xs={12}>
          <div className={styles['ai-summary']}>
            <div className={styles['ai-summary__title']}>{t('title')}</div>
            <div className={styles['ai-summary__icons']}>
              {aiLogos.map(({icon, alt, url, name}) => (
                <Link
                  key={alt}
                  href={`${url}${urlSafePrompt}`}
                  title={t(alt)}
                  target="_blank"
                  customAttributes={{
                    'data-gtm': 'ai-summary-logo',
                    'data-ui': `ai-summary-logo-${name}`
                  }}>
                  <Img src={icon} alt={t(alt)} />
                </Link>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AISummary;
